import { MDTApi } from './mdtapi.js';

export const unreadNotifications = async (data) => {
    return await MDTApi.call('api.notifications.count', {
        params: data,
        method: 'GET'
    });
}